// extracted by mini-css-extract-plugin
export default {"root":"dPH8Y__root","editorLoading":"ekfGx__editorLoading"};